<template src="./Comprados.html"></template>
<style lang="scss" scoped src="./Comprados.scss"></style>

<script>
import { translate } from '../../../services/translate.service';
import service from '../../../services/qrcode.service';
import { types } from '../../../store';
import {redirect} from '../../../helpers/helpers'
import * as helper from '../helper';
export default {
  name: 'bilhete-especial-comprados',
  props:{
    data:{
      type: Object
    },
  },
  components: {
  },
  data() {
    return {
      loaded: false,
      service,
      helper,
    }
  },
  computed: {
    current() {
      return this.$store.state.qrcode_current || null;
    },
    items() {
      return this.$store.state.qrcode_comprados || [];
    },
    selected() {
      return this.$store.state.qrcode_selected || []
    },
  },
  methods: {
    t:translate,
    _status(status, traduz = false) {
      if(status == helper.StatusQRCodes.Disponivel) return traduz ? translate('QRCODE_DISPONIVEL') : 'disponível';
      if(status == helper.StatusQRCodes.Expirado) return traduz ? translate('QRCODE_EXPIRADO') : 'expirado';
      if(status == helper.StatusQRCodes.PendenteGeracao || status == helper.StatusQRCodes.PendentePagamento) return traduz ? translate('QRCODE_PENDENTE') : 'pendente';
      if(status == helper.StatusQRCodes.Utilizado) return traduz ? translate('QRCODE_UTILIZADO') : 'utilizado';
      return status;
    },
    open(bilhete) {
      if(bilhete.status == helper.StatusQRCodes.Disponivel) {
        if(sessionStorage.getItem("giro-token")) {
          this.$store.dispatch(types.SET_QRCODE_DETALHE, bilhete);
          this.$router.push({ name: 'bilhete-especial-detalhe' });
        }
      }
    }
  },
  mounted(){
    if(!sessionStorage.getItem("giro-token"))
      redirect("login",this);
    if(!this.current) {
      this.$router.push({ name: 'home' });
      return;
    }
    service.getQRCodesComprados().then(res => {
      this.loaded = true;
      this.$store.dispatch(types.SET_QRCODE_COMPRADOS, res.data);
    }).catch(({ response }) => {
      if(response.status == 401) {
        redirect("login",this);
      }
    });
  }
}
</script>
